import { LocalizationHelper } from '../../../../helpers/localization-helper'

import { BasicParameter } from '../../../common/parameters/extensions'
import { LocationsMassGroupsAssigningProgressStep } from '../../locations-mass-groups-edit/locations-mass-groups-edit.interfaces'

// #region Consts

export const SERVICE_NAME: string = 'LocationsMassGroupsEditErrorsSummaryService'

// #endregion

// #region LocationsMassGroupsEditErrorsSummaryService

export class LocationsMassGroupsEditErrorsSummaryService {

    public createErrorsSummaryParameters(currentProgressStep: LocationsMassGroupsAssigningProgressStep): BasicParameter[] {

        const parameters: BasicParameter[] = []
        
        const allCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AllCount)
        }
        
        const successCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SuccessCount)
        }

        const errorCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ErrorCount)
        }

        if (
            currentProgressStep != null &&
            currentProgressStep.itemsCount != null &&
            currentProgressStep.successItemsCount != null &&
            currentProgressStep.errorItemsCount != null
        ) {
            allCountParameter.value = currentProgressStep.itemsCount
            successCountParameter.value = currentProgressStep.successItemsCount
            errorCountParameter.value = currentProgressStep.errorItemsCount
        }

        parameters.push(
            allCountParameter,
            successCountParameter,
            errorCountParameter
        )

        return parameters
    }
}

// #endregion